var React = require('react');

function Linkout (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.5 2.5C6.77614 2.5 7 2.27614 7 2C7 1.72386 6.77614 1.5 6.5 1.5H4C2.34315 1.5 1 2.84315 1 4.5V12.5C1 14.1569 2.34315 15.5 4 15.5H12C13.6569 15.5 15 14.1569 15 12.5V10C15 9.72386 14.7761 9.5 14.5 9.5C14.2239 9.5 14 9.72386 14 10V12.5C14 13.6046 13.1046 14.5 12 14.5H4C2.89543 14.5 2 13.6046 2 12.5V4.5C2 3.39543 2.89543 2.5 4 2.5H6.5ZM15 1.5H14.5001H14.4999H9C8.72386 1.5 8.5 1.72386 8.5 2C8.5 2.27614 8.72386 2.5 9 2.5H13.2929L6.64645 9.14645C6.45118 9.34171 6.45118 9.65829 6.64645 9.85355C6.84171 10.0488 7.15829 10.0488 7.35355 9.85355L14 3.20711V7.5C14 7.77614 14.2239 8 14.5 8C14.7761 8 15 7.77614 15 7.5V2.00098V1.99902V1.5Z","fill":"#E8EFFF"})));
}

Linkout.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Linkout;

Linkout.default = Linkout;
